import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Grid from '../symmetry-grid/components/grid';

// eslint-disable-next-line @typescript-eslint/no-empty-function
function InfoCard({ textLines = [], isInput = false, btnText = 'Button', finalStep = false, grid, submit = () => {} }) {
  const [text, setText] = useState('');

  const lines = textLines.sort((a, b) => (a.orderNum > b.orderNum ? 1 : -1));

  const handleTextChanged = ({ target }) => {
    const { value } = target;
    setText(value);
  };

  const handleSubmit = () => {
    if (isInput) {
      submit(text);
    } else {
      submit(finalStep);
    }
  };

  return (
    <div style={{ minWidth: '500px' }} className="d-flex flex-column">
      <div className="w-75 mx-auto justify-content-center">
        {lines.map((line) => (
          <p key={line.orderNum} className="lh-1 text-larger text-bolder">
            {line.text}
            {line.bullets && (
              <ul className="pt-1">
                {line.bullets.map((bullet) => (
                  <li key={Math.random()}>{bullet}</li>
                ))}
              </ul>
            )}
          </p>
        ))}
      </div>

      {grid && (
        <div className="m-auto">
          <Grid cells={grid.cells} centerLine={grid.centerLine} infoCard />
        </div>
      )}

      {isInput && (
        <div className="d-flex justify-content-center my-2">
          <input type="text" className="form-control" onChange={handleTextChanged} value={text} />
        </div>
      )}
      <div className="d-flex justify-content-center my-2">
        <Button
          key={Math.random()}
          className="btn-assessment-primary"
          disabled={isInput && text.length < 1}
          onClick={(event) => {
            event.target.blur();
            handleSubmit();
          }}
        >
          {btnText}
        </Button>
      </div>
    </div>
  );
}

export default InfoCard;
